/**
 * @desc Polyfills
 */
import 'promise-polyfill/src/polyfill';
import 'core-js/features/typed-array';
import 'core-js/stable/array/includes';

/**
 * @desc Primary
 * 1
 */
import namespace from '@jsc/namespace';

namespace();
